module.exports = __webpack_public_path__ + "img/save.bb4e8e08.svg";